module.exports = __webpack_public_path__ + "static/media/carousel-image2.44a9dd59.png";